var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorMsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2002_25",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00033 1.33333C11.6802 1.33351 14.6663 4.32043 14.6663 8.00033C14.6662 11.6801 11.6801 14.6662 8.00033 14.6663C4.32044 14.6663 1.33351 11.6802 1.33333 8.00033C1.33333 4.32033 4.32033 1.33333 8.00033 1.33333ZM7.33333 10.0003V11.3333H8.66634V10.0003H7.33333ZM8.00033 4.66634C7.63366 4.66634 7.33333 4.96667 7.33333 5.33333V8.00033C7.33351 8.36684 7.63377 8.66634 8.00033 8.66634C8.36674 8.66616 8.66616 8.36674 8.66634 8.00033V5.33333C8.66634 4.96677 8.36684 4.66652 8.00033 4.66634Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2002_25)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#EF3826"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorMsg);
export default __webpack_public_path__ + "static/media/error-msg.2ead4db95139031628108f0547c80d74.svg";
export { ForwardRef as ReactComponent };